import { cms } from 'api';
import {
  FETCH_RESOURCES,
  UPDATE_RESOURCES,
  FETCH_ELEMENT_INFO,
  FETCH_APPS,
  UPDATE_APPS,
  UPDATE_ELEMENT,
  CREATE_TEMPLATE,
  DELETE_TEMPLATE,
  CREATE_PATTERN,
  DELETE_PATTERN,
  CREATE_ELEMENT,
  DELETE_ELEMENT,
  UPDATE_ELEMENT_INFO,
  FETCH_PARTNERS,
  UPDATE_PARTNERS
} from 'store/actions/cms';

export default {
  [FETCH_APPS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      cms.getApps().then(
        resp => {
          const apps = resp.data || [];
          commit(UPDATE_APPS, apps);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [FETCH_RESOURCES]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.getDocumentList(data).then(
        resp => {
          const resources = resp.data || [];
          commit(UPDATE_RESOURCES, {
            resources,
            partnerId: data.partnerId
          });
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [FETCH_ELEMENT_INFO]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.getElementInfo(data).then(
        resp => {
          const result = resp.data || {};
          commit(UPDATE_ELEMENT, result);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [CREATE_TEMPLATE]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.createTemplate(data).then(
        () => {
          commit(CREATE_TEMPLATE, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [DELETE_TEMPLATE]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.deleteTemplate(data).then(
        () => {
          commit(DELETE_TEMPLATE, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [CREATE_PATTERN]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.createPattern(data).then(
        () => {
          commit(CREATE_PATTERN, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [DELETE_PATTERN]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.deletePattern(data).then(
        () => {
          commit(DELETE_PATTERN, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [CREATE_ELEMENT]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.createElement(data).then(
        () => {
          commit(CREATE_ELEMENT, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [DELETE_ELEMENT]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      cms.deleteElement(data).then(
        () => {
          commit(DELETE_ELEMENT, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [UPDATE_ELEMENT_INFO]: (params, data) =>
    new Promise((resolve, reject) => {
      cms.updateElement(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [FETCH_PARTNERS]: ({ commit }, appId) =>
    new Promise((resolve, reject) => {
      cms.getPartners(appId).then(
        resp => {
          commit(UPDATE_PARTNERS, resp.data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    })
};
